export default __webpack_public_path__ + "static/media/thumb-6.b615fc8e.png";